export function trimText(text, limit) {
    return text.length > limit
        ? text.substr(0, limit) + '・・・' : text;
}